import script from "./timeline-hotspot-point.vue?vue&type=script&setup=true&lang=js"
export * from "./timeline-hotspot-point.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__